<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qmFgEk/tc-custom/9781488013218.jpg?1704825536818" alt="This image is the cover for the book Military Grade Mistletoe, The Precinct"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Military Grade Mistletoe, The Precinct
      </h1>
      <p class="bookDescription body article font2">
        <b><i>She saved his life when everything was hopeless. He’s determined to return the favor.</i></b><b></b><br/><br/>Not even Master Sergeant Harry Lockhart’s military expertise could stop the IED that killed his team and left him injured. Only Daisy Gunderson—a pen pal he’d never met—and her kind letters helped him survive. But Daisy in the flesh is the surly Marine’s polar opposite. She’s outgoing, talkative and putting his military training on high alert. A stalker named Secret Santa is targeting the kindhearted teacher…and the pranks are growing deadly.<br/><br/>In Daisy, Harry’s finally found the safe haven he needs. And he’ll be damned if anyone is going to take her from him.<br/><br/><b>The Precinct</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Miller
      </h2>
      
      <p class="authorDescription body article">USA TODAY bestselling author Julie Miller writes breathtaking romantic suspense. She has sold millions of copies of her books worldwide, and has earned a National Readers Choice Award, two Daphne du Maurier prizes and an RT BookReviews Career Achievement Award. For a complete list of her books and more, go to <a href="http://www.juliemiller.org">www.juliemiller.org</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?186157fa